module.exports = __webpack_public_path__ + "static/media/5.2cd3b06b.jpg";